// ── Reusable option sets ─────────────────────────────────────────────────────
export const RESULT_OPTIONS = [
    { value: 'HOME', label: 'Home' },
    { value: 'DRAW', label: 'Draw' },
    { value: 'AWAY', label: 'Away' }
];
export const YES_NO = [
    { value: 'YES', label: 'Yes' },
    { value: 'NO', label: 'No' }
];
// ── Derived-fact helpers (pure reads off a settled FixtureResult) ────────────
const totalGoals = (r) => r.homeGoals + r.awayGoals;
/** Does the result carry half-time goals (so HT markets can grade)? */
export function hasHalftime(r) {
    return r.halftimeHome != null && r.halftimeAway != null;
}
/** Does the result carry per-side card counts (so the mostCards market can grade)? */
export function hasCards(r) {
    return r.homeCards != null && r.awayCards != null;
}
/** Does the result carry per-side corners (so the corner markets can grade)? */
export function hasCorners(r) {
    return r.homeCorners != null && r.awayCorners != null;
}
/** Did EITHER team win without conceding? (the "win to nil" market). A draw is NO. */
export function winToNil(r) {
    if (r.homeGoals > r.awayGoals)
        return r.awayGoals === 0;
    if (r.awayGoals > r.homeGoals)
        return r.homeGoals === 0;
    return false;
}
/** Did both teams score in the FIRST half? (caller must check {@link hasHalftime}). */
export function firstHalfBtts(r) {
    return (r.halftimeHome ?? 0) > 0 && (r.halftimeAway ?? 0) > 0;
}
/** Which side took more corners (caller must check {@link hasCorners}). */
export function cornersBucket(r) {
    const h = r.homeCorners ?? 0;
    const a = r.awayCorners ?? 0;
    return h > a ? 'HOME' : a > h ? 'AWAY' : 'DRAW';
}
/** Canonical 1X2 of the half-time score (caller must check {@link hasHalftime}). */
export function halftimeOutcome(r) {
    const h = r.halftimeHome ?? 0;
    const a = r.halftimeAway ?? 0;
    return h > a ? 'HOME' : h < a ? 'AWAY' : 'DRAW';
}
/** Goals scored in the first half (= half-time total). */
export function firstHalfGoals(r) {
    return (r.halftimeHome ?? 0) + (r.halftimeAway ?? 0);
}
/** Goals scored in the second half (full-time total − half-time total). */
export function secondHalfGoals(r) {
    return Math.max(0, totalGoals(r) - firstHalfGoals(r));
}
export function marginBucket(r) {
    const m = Math.abs(r.homeGoals - r.awayGoals);
    return m === 0 ? 'DRAW' : m === 1 ? 'ONE' : 'TWO_PLUS';
}
export function goalBand(r) {
    const t = totalGoals(r);
    return t <= 1 ? 'B0_1' : t <= 3 ? 'B2_3' : 'B4';
}
export function topHalf(r) {
    const first = firstHalfGoals(r);
    const second = secondHalfGoals(r);
    return first > second ? 'FIRST' : second > first ? 'SECOND' : 'EQUAL';
}
export function cardsBucket(r) {
    const h = r.homeCards ?? 0;
    const a = r.awayCards ?? 0;
    return h > a ? 'HOME' : a > h ? 'AWAY' : 'DRAW';
}
//# sourceMappingURL=helpers.js.map